import { Component, Inject, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { Combo2 } from '../../../models/combo';
import { Adherido } from '../../../models/adherido';
import { AttachedService } from '../../../services/attached.service';
import { SpinnerService } from '../../../services/spinner.service';
import { SnackbarService } from '../../../services/snackbar.service';
import {
  AdheridoControllerService,
} from 'api-rest';

@Component({
  selector: 'lib-new-document-dialog',
  templateUrl: './new-document-dialog.component.html',
  styleUrls: ['./new-document-dialog.component.scss']
})
export class NewDocumentDialogComponent implements OnInit {

  formGroup!: FormGroup;
  adherido!: Adherido;
  tiposDocumento: Combo2[] = [];
  adjuntosBlob: Array<File> = [];
  botonEstado: boolean = false;
  flagTooltip:boolean = false;

  containerAdheridos: string = this.environment.documentContainerAdheridos;

  constructor(
    @Inject('environment') private environment: any,
    public dialogRef: MatDialogRef<NewDocumentDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private formBuilder: FormBuilder,
    private adheridoSrv: AdheridoControllerService,
    private attachedSrv: AttachedService,
    public spinnerSrv: SpinnerService,
    private snackbarSrv: SnackbarService
  ) {
    this.adherido = this.data.adherido;

    this.formGroup = this.formBuilder.group({
      tipoDocumento: [{ value: null, disabled: false }, { validators: Validators.compose([Validators.required]) }],
      fechaFirma: [{ value: null, disabled: false }],
      descripcion: [{ value: null, disabled: false }, {validators: Validators.compose([Validators.maxLength(255)])} ]
    });
   }

  ngOnInit(): void {
    this.cargarDocumentos();
    this.cargarTooltip();
  }

  cargarTooltip(){
    this.formGroup.get('tipoDocumento')?.valueChanges.subscribe((value: any) => {
      if(value==4){
        this.flagTooltip=true;
      }else{
        this.flagTooltip=false;
      }

      const fechaFirmaControl = this.formGroup.get('fechaFirma');
      if (value == 1 && this.adherido?.estado?.id === 3) {
        fechaFirmaControl?.setValidators([Validators.required]);
      } else {
        fechaFirmaControl?.clearValidators();
        fechaFirmaControl?.setValue(null);
      }
      fechaFirmaControl?.updateValueAndValidity();
    });
  }

  cargarDocumentos(): void{
    this.attachedSrv.getTiposDocumento()
      .subscribe({
        next: (response: Combo2[]) => {
          // Filtrar solo los documentos con ids 1, 4 y 5 (contrato, otros, adenda)
          this.tiposDocumento = response.filter(doc => [1, 4, 5].includes(Number(doc.id)));
        },
        error: err => {
          console.log(err);
          this.snackbarSrv.showSnackBar('Error al cargar datos', 'error');
        }
      });
  }

  cerrar(): void {
    this.dialogRef.close(null);
  }

  guardar(): void {
    this.formGroup.markAllAsTouched();
    this.formGroup.updateValueAndValidity();
    if (this.formGroup.valid) {
     if (this.adjuntosBlob?.length > 0) {
      let id = this.adherido.id! ?? null;
      let typeDoc = this.formGroup.controls['tipoDocumento'].value! ?? null;
      let docDesc = this.formGroup.controls['descripcion'].value! ?? '';
      let fechaFirma = this.formGroup.controls['fechaFirma'].value;

      this.setBotonEstado(true);
      this.spinnerSrv.loadingShow();
      this.attachedSrv.postDocumento(this.adjuntosBlob[0], this.containerAdheridos, typeDoc, docDesc, id, 'adherido', this.adjuntosBlob[0]?.name, undefined)
        .subscribe({
          next: () => {
            if (typeDoc === 1) {
              let adheridoUpdate: any = { ...this.adherido };
              try {
                if (fechaFirma) {
                  let d = new Date(fechaFirma);
                  adheridoUpdate.fechaFirmaContrato = Date.UTC(d.getFullYear(), d.getMonth(), d.getDate());
                }
              } catch (error) {
                console.error('Error procesando la fecha: ', error);
              }
              
              this.adheridoSrv.actualizarAdherido(id!, adheridoUpdate).subscribe({
                next: () => {
                  if (this.adherido.estado?.id === 3) {
                    this.adheridoSrv.multipleActualizarEstado(10, { adheridosIds: [id!] }).subscribe({
                      next: (value: any) => {
                        this.spinnerSrv.loadingHide();
                        this.snackbarSrv.showSnackBar('Documento subido satisfactoriamente', 'success');
                        this.dialogRef.close(true);
                      },
                      error: (err: { message: any }) => {
                        this.spinnerSrv.loadingHide();
                        this.snackbarSrv.showSnackBar('Documento subido pero hubo un error al actualizar el estado', 'error');
                        this.dialogRef.close(true);
                      },
                    });
                  } else {
                    this.spinnerSrv.loadingHide();
                    this.snackbarSrv.showSnackBar('Documento subido satisfactoriamente', 'success');
                    this.dialogRef.close(true);
                  }
                },
                error: err => {
                  this.spinnerSrv.loadingHide();
                  this.setBotonEstado(false);
                  this.snackbarSrv.showSnackBar('Error al actualizar el adherido', 'error');
                }
              });
            } else {
              this.spinnerSrv.loadingHide();
              this.snackbarSrv.showSnackBar('Documento subido satisfactoriamente', 'success');
              this.dialogRef.close(true);
            }
          },
          error: err => {
            this.spinnerSrv.loadingHide();
            this.setBotonEstado(false);
            this.snackbarSrv.showSnackBar('Error al subir documento', 'error');
          }
        });
      }
    }
  }
  controlHasError(controlName: string, errorName: string) {
    return this.formGroup.controls[controlName].hasError(errorName)
      && this.formGroup.controls[controlName].touched;
  }

  attachAdjunto(archivo: File | null): void {
    if (archivo != null) {
      if (archivo.size === 0) {
        this.snackbarSrv.showSnackBar(
          'No se puede subir un fichero vacío',
          'error'
        );
      } else if (archivo.size > 12 * 1024 * 1024) { // 5 MB
        this.snackbarSrv.showSnackBar(
          'El fichero supera el tamaño máximo permitido de 12 MB',
          'error'
        );
      } else {
        this.adjuntosBlob.push(archivo);
      }
    }
  }

  setBotonEstado(estado: boolean) {
      return  this.botonEstado = estado;
  }

}
